import { render, staticRenderFns } from "./AutomationList.vue?vue&type=template&id=71a51aaa&scoped=true"
import script from "./AutomationList.vue?vue&type=script&lang=js"
export * from "./AutomationList.vue?vue&type=script&lang=js"
import style0 from "./AutomationList.vue?vue&type=style&index=0&id=71a51aaa&prod&scoped=true&lang=scss"
import style1 from "./AutomationList.vue?vue&type=style&index=1&id=71a51aaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a51aaa",
  null
  
)

export default component.exports